import { render, staticRenderFns } from "./PackIconsEntity.vue?vue&type=template&id=22f0f756&"
import script from "./PackIconsEntity.vue?vue&type=script&lang=js&"
export * from "./PackIconsEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports